import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators'
import OnboardingStoreModuleContainer from './OnboardingStoreModuleContainer'

import CoreStoreModule from './CoreStoreModule'

import AppAction from './AppAction'

export type OnboardingApp = 'user' | 'organization' | 'other'

@Module({
  name: 'onboarding',
  namespaced: true,
  stateFactory: true
})
export default class OnboardingStoreModule extends VuexModule {
  private _coreStoreModule: CoreStoreModule | null = null
  private _appName: OnboardingApp | null = null

  @Mutation
  public inject (container: OnboardingStoreModuleContainer) {
    this._coreStoreModule = container.coreStoreModule
    this._appName = container.appName
  }

  get needUser () {
    if (this._coreStoreModule === null) {
      return
    }
    const hasUser = this._coreStoreModule.userProfile !== null
    switch (this._appName) {
      case 'other':
        return !hasUser
      case 'user':
        return false
      case 'organization':
        return !hasUser
    }
  }

  get needOrganization () {
    if (this._coreStoreModule === null) {
      return
    }
    if (this.needUser) {
      return false
    }
    const hasOrganization = this._coreStoreModule.activeUserOrganization !== null
    const hasOrganizations = this._coreStoreModule.userOrganizations !== null && this._coreStoreModule.userOrganizations.length > 0
    switch (this._appName) {
      case 'other':
        return !hasOrganization
      case 'user':
        return hasOrganizations === false
      case 'organization':
        return false
    }
  }

  // Required actions system
  get requiredAction () {
    if (this._coreStoreModule === null) {
      return
    }
    if (this.needUser) {
      const action = new AppAction()
      action.title = 'shared.ONBOARDING.CREATE_PROFILE_TITLE'
      action.message = 'shared.ONBOARDING.CREATE_PROFILE_MESSAGE'
      action.link = 'shared.ONBOARDING.CREATE_PROFILE_ACTION'
      action.href = '/onboarding/'
      return action
    } else if (this.needOrganization && this._coreStoreModule.userProfile !== null) {
      const action = new AppAction()
      action.title = 'shared.ONBOARDING.CREATE_ORGANIZATION_TITLE'
      action.message = 'shared.ONBOARDING.CREATE_ORGANIZATION_MESSAGE'
      action.link = 'shared.ONBOARDING.CREATE_ORGANIZATION_ACTION'
      action.href = '/onboarding/'
      return action
    } else {
      return null
    }
  }
}
